import React from "react";
import BusinessDetailsComponent from "./BusinessDetailsComponent";
import AssignRepresentativeComponent from "./AssignRepresentativeComponent";
import AssignRepresentativeComponentV2 from "./AssignRepresentativeComponentV2";
import BusinessDetailsComponentV3 from "./BusinessDetailsComponentV3";
import NIBiddingApplicationForm from "./NIBiddingApplicationForm";
import BidApplicationFormWithOutPD from "./IndividualBidders/BidApplicationFormWithOutPD";
import NIDeclarationComponent from "./NIDeclarationComponent";
import NITermsAndConditions from "./NITermsAndConditions";
import NIESignComponent from "./NIESignComponent";
import NICompletedComponent from "./NICompletedComponent";

interface NonIndividualOnlineKycStepContentProps {
  activeStep: number;
  bidderUuid: any;
  bidder: any;
  setActiveStep: any;
  init: any;
  offlinePaymentValidation: boolean;
  stepsTitles: Array<{ label: string; value: string }>;
  enableUpdatedKyc: boolean;
}

export default function NonIndividualOnlineKycStepContent({
  activeStep,
  bidderUuid,
  bidder,
  setActiveStep,
  init,
  offlinePaymentValidation,
  stepsTitles,
  enableUpdatedKyc,
}: NonIndividualOnlineKycStepContentProps) {
  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return enableUpdatedKyc ? (
          <BusinessDetailsComponentV3
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        ) : (
          <BusinessDetailsComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 1:
        return (
          <AssignRepresentativeComponentV2
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      // enableUpdatedKyc ? (
      // ) : (
      //   <AssignRepresentativeComponent
      //     bidderUuid={bidderUuid}
      //     stepsTitles={stepsTitles}
      //     activeStep={activeStep}
      //     setActiveStep={setActiveStep}
      //     init={init}
      //   />
      // );
      case 2:
        return offlinePaymentValidation ? (
          <BidApplicationFormWithOutPD
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            bidder={bidder}
            outerNextStep="bid_details"
          />
        ) : (
          <NIBiddingApplicationForm
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep="bid_details"
            hideHeader={true}
          />
        );
      case 3:
        return (
          <NIDeclarationComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            setActiveStep={setActiveStep}
            activeStep={activeStep}
            init={init}
            outerNextStep="ar_declaration"
          />
        );
      case 4:
        return (
          <NITermsAndConditions
            bidderUuid={bidderUuid}
            bidder={bidder}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            outerNextStep="t_&_c"
          />
        );
      case 5:
        return (
          <NIESignComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            requestId={bidder?.esigned_data?.request_id}
          />
        );
      case 6:
        return <NICompletedComponent bidderUuid={bidderUuid} />;
      default:
        return null;
    }
  };

  return (
    <div className="p-2 md:p-4 bg-white">
      {/* {activeStep !== 3 &&
        activeStep !== 2 &&
        activeStep !== 1 &&
        activeStep !== 0 && (
          <div className="flex flex-col sm:flex-row justify-between sm:items-center gap-2 mb-4">
            <h4 className="font-bold text-lg font-openSans flex-1">
              {stepsTitles?.[activeStep]?.label}
            </h4>
          </div>
        )} */}
      {renderStepContent()}
    </div>
  );
}
